import {
    faPencilAlt,
    faTachometerAlt,
    faClipboardList,
    faMobileAlt,
    faIdCard,
    faQrcode,
    faCog,
    faCommentAlt,
    faHome,
    faArrowAltCircleDown,
    faChevronDown,
    faChevronRight,
    faUser,
    faUserPlus,
    faBell,
    faSearch,
    faSearchMinus,
    faFilter,
    faTrashAlt,
    faTimes,
    faCheckCircle,
    faSpinner,
    faDownload,
    faSave,
    faBan,
    faInfoCircle,
    faHourglass,
    faExclamationCircle,
    faExclamationTriangle,
    faShoppingCart,
    faCircle,
    faDroplet,
    faCalendarAlt,
    faUserGroup,
    faTag,
    faMobileScreenButton,
    faWallet,
    faCreditCard,
    faEye,
    faEyeSlash,
    faHeart,
    faSun,
    faMoon,
    faShoppingBasket,
    faMap,
    faDirections,
    faCircleChevronLeft,
    faPowerOff,
    faBars,
    faEllipsis,
    faEllipsisV,
    faX,
    faGift,
    faCarSide,
    faBarcode,
    faPlus,
    faMinus,
    faHistory,
    faEnvelope,
    faPhone,
    faCar,
    faList,
    faMapPin,
    faArrowUpFromBracket,
    faSquarePlus,
    faDollarSign,
    faAward,
    faArrowRotateRight,
    faLock,
    faMicrophoneSlash,
    faMicrophone,
    faPaperPlane,
    faBrain,
    faCommentSlash,
    faPenToSquare,
    faUndo,
    faCheck,
    faSkull,
    faPaste,
    faTruckMedical,
    faRightFromBracket,
    faMagnifyingGlass,
    faGauge,
    faCircleXmark,
    faArrowRight,
    faChartLine,
    faStar,
    faLink,
    faWrench,
    faExpand,
    faCompress,
    faPause,
    faPlay,
    faMessage,
    faArrowTurnUp,
    faArrowTurnDown,
    faMapLocationDot,
    faScaleUnbalanced,
    faCoins,
    faQuestionCircle,
    faSkullCrossbones,
    faPeopleRoof,
    faCrown,
    faArrowDownShortWide,
    faArrowUpWideShort,
    faHeading,
    faArrowLeft,
    faBullhorn,
    faCamera,
    faMask,
    faFlag,
    faRotateLeft
} from '@fortawesome/free-solid-svg-icons';

export const IconIndex = {
    camera: faCamera,
    bullhorn: faBullhorn,
    heading: faHeading,
    pull: faArrowDownShortWide,
    push: faArrowUpWideShort,
    crown: faCrown,
    family: faPeopleRoof,
    skull: faSkullCrossbones,
    questionMark: faQuestionCircle,
    coins: faCoins,
    scale: faScaleUnbalanced,
    mapLocation: faMapLocationDot,
    arrowTurnDown: faArrowTurnDown,
    arrowTurnUp: faArrowTurnUp,
    message: faMessage,
    play: faPlay,
    pause: faPause,
    compress: faCompress,
    expand: faExpand,
    wrench: faWrench,
    link: faLink,
    star: faStar,
    lineChart: faChartLine,
    arrowRight: faArrowRight,
    arrowLeft: faArrowLeft,
    circleCross: faCircleXmark,
    gauge: faGauge,
    magnifyingGlass: faMagnifyingGlass,
    signOut: faRightFromBracket,
    medicalTruck: faTruckMedical,
    paste: faPaste,
    skull: faSkull,
    check: faCheck,
    undo: faUndo,
    edit: faPenToSquare,
    commentSlash: faCommentSlash,
    brain: faBrain,
    paperPlane: faPaperPlane,
    mic: faMicrophone,
    micSlash: faMicrophoneSlash,
    pencil: faPencilAlt,
    tachometer: faTachometerAlt,
    clipboard: faClipboardList,
    mobileAlt: faMobileAlt,
    idCard: faIdCard,
    QRcode: faQrcode,
    cog: faCog,
    comment: faCommentAlt,
    home: faHome,
    arrowCircleDown: faArrowAltCircleDown,
    chevronDown: faChevronDown,
    chevronRight: faChevronRight,
    user: faUser,
    userPlus: faUserPlus,
    bell: faBell,
    search: faSearch,
    searchMinus: faSearchMinus,
    filter: faFilter,
    trash: faTrashAlt,
    times: faTimes,
    checkCircle: faCheckCircle,
    spinner: faSpinner,
    download: faDownload,
    save: faSave,
    ban: faBan,
    infoCircle: faInfoCircle,
    hourglass: faHourglass,
    exclamationCircle: faExclamationCircle,
    exclamationTriangle: faExclamationTriangle,
    cart: faShoppingCart,
    circle: faCircle,
    drop: faDroplet,
    calendar: faCalendarAlt,
    group: faUserGroup,
    tag: faTag,
    mobile: faMobileScreenButton,
    wallet: faWallet,
    creditCard: faCreditCard,
    eye: faEye,
    crossEye: faEyeSlash,
    heart: faHeart,
    sun: faSun,
    moon: faMoon,
    basket: faShoppingBasket,
    map: faMap,
    directions: faDirections,
    circleChevronLeft: faCircleChevronLeft,
    power: faPowerOff,
    bars: faBars,
    cross: faX,
    gift: faGift,
    sideCar: faCarSide,
    barcode: faBarcode,
    plus: faPlus,
    minus: faMinus,
    history: faHistory,
    envelope: faEnvelope,
    phone: faPhone,
    car: faCar,
    list: faList,
    pin: faMapPin,
    share: faArrowUpFromBracket,
    squarePlus: faSquarePlus,
    dollarSign: faDollarSign,
    award: faAward,
    reload: faArrowRotateRight,
    lock: faLock,
    mask: faMask,
    elipsis: faEllipsis,
    elipsisVertical: faEllipsisV,
    flag: faFlag,
    rotateleft: faRotateLeft
};